<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        <a
          href="#"
          @click.prevent="$router.push({ name: 'home' })"
          v-tooltip="$t('back')"
          class="mr-2"
        >
          <i class="fas fa-arrow-left"></i>
        </a>
        {{ $t('homePage.myApproval') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('homePage.myApproval'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <div>
        <ts-card>
          <ts-card-wrapper>
            <div class="ts-flex">
              <div class="ts-flex-grow"></div>
              <div class="ts-flex justify-content-end">
                <select class="form-control mr-2" v-model="app_type_id">
                  <option
                    v-for="(app_type, index) in approveTypes"
                    :key="index"
                    :value="app_type.app_type_id"
                    >{{ app_type.app_type }}</option
                  >
                </select>
                <select class="form-control" v-model="approve_status">
                  <option value>{{ $t('home.all') }}</option>
                  <option :value="0">{{ $t('home.pending') }}</option>
                  <option :value="1">{{ $t('home.approved') }}</option>
                  <option :value="2">{{ $t('home.rejected') }}</option>
                </select>
              </div>
            </div>
          </ts-card-wrapper>
          <div class="overflow-auto">
            <ts-table
              :columns="columns"
              :records="resources"
              :loading="loading"
            >
              <template v-slot="{ record }">
                <td class="ts-whitespace-no-wrap">{{ record.request_date }}</td>
                <td class="ts-whitespace-no-wrap">
                  {{ record.request_initiator }}
                </td>
                <td class="ts-whitespace-no-wrap">{{ record.class_name }}</td>
                <td class="ts-whitespace-no-wrap">
                  {{ record.subject_name_foreign }}
                </td>
                <td class="ts-whitespace-no-wrap text-center">
                  <span
                    class="badge badge-info"
                    v-if="record.request_status == 'Pending'"
                    >{{ $t('home.pending') }}</span
                  >
                  <span
                    class="badge badge-primary"
                    v-if="record.request_status == 'Partialy Approved'"
                    >{{ $t('home.partiallyApproved') }}</span
                  >
                  <span
                    class="badge badge-success"
                    v-if="record.request_status == 'Approved'"
                    >{{ $t('home.approved') }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="record.request_status == 'Rejected'"
                    >{{ $t('home.rejected') }}</span
                  >
                </td>
                <td class="ts-whitespace-no-wrap">
                  {{ record.approved_comments }}
                </td>
                <td class="ts-whitespace-no-wrap text-center">
                  <a
                    href="#"
                    v-tooltip="$t('show')"
                    class="mr-2 text-info"
                    @click.prevent="onView(record)"
                  >
                    <i class="fas fa-eye"></i>
                  </a>
                  <a
                    v-if="
                      record.is_approvable == 1 &&
                        record.request_status != 'Approved' &&
                        record.request_status != 'Rejected'
                    "
                    href="#"
                    v-tooltip="$t('reject')"
                    class="mr-2 text-danger"
                    @click.prevent="showReasonForm(2, record)"
                  >
                    <i class="fas fa-times-circle"></i>
                  </a>
                  <a
                    v-if="
                      record.is_approvable == 1 &&
                        record.request_status != 'Approved' &&
                        record.request_status != 'Rejected'
                    "
                    href="#"
                    v-tooltip="record.app_activity"
                    class="text-primary"
                    @click.prevent="showReasonForm(1, record)"
                  >
                    <i class="fas fa-check-circle"></i>
                  </a>
                </td>
              </template>
            </ts-table>
          </div>
          <div class="d-flex justify-content-end p-15">
            <ts-pagination
              v-model="pagination"
              @navigate="fetchData"
            ></ts-pagination>
          </div>
        </ts-card>
      </div>
    </ts-card>
    <a-modal
      v-if="view_homework"
      v-model="view_homework"
      :title="$t('view')"
      :footer="null"
      :zIndex="1020"
      width="500px"
      @cancel="closeHomeworkModel"
    >
      <view-homework :record="homework" @close="view_homework = false" />
    </a-modal>
    <a-modal
      v-if="view_father"
      v-model="view_father"
      :title="$t('profileApproval.father')"
      :footer="null"
      :zIndex="1020"
      width="70%"
      @cancel="closeFatherModel"
    >
      <view-father :record="father" @close="view_father = false" />
    </a-modal>
    <a-modal
      v-if="view_mother"
      v-model="view_mother"
      :title="$t('profileApproval.mother')"
      :footer="null"
      :zIndex="1020"
      width="70%"
      @cancel="closeMotherModel"
    >
      <view-mother :record="mother" @close="view_mother = false" />
    </a-modal>
    <a-modal
      v-if="view_student"
      v-model="view_student"
      :title="$t('profileApproval.student')"
      :footer="null"
      :zIndex="1020"
      width="70%"
      @cancel="closeStudentModel"
    >
      <view-student :record="student" @close="view_student = false" />
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import ReasonComponent from './approval-reason'
import ViewHomework from './view-homework'
import ViewFather from './view-father'
import ViewMother from './view-mother'
import ViewStudent from './view-student'

export default {
  name: 'homeworkApproval',
  components: {
    ViewHomework,
    ViewFather,
    ViewMother,
    ViewStudent
  },
  data() {
    return {
      loading: false,
      view_homework: false,
      view_father: false,
      view_mother: false,
      view_student: false,
      homework: [],
      father: [],
      mother: [],
      student: []
    }
  },
  created() {
    this.fetchResource()
  },
  computed: {
    ...mapState('home/staffMyApproval', [
      'resources',
      'pagination',
      'approveTypes'
    ]),
    search: {
      get() {
        return this.$store.state.home.staffMyApproval.search
      },
      set(newVal) {
        this.$store.commit('home/staffMyApproval/SET_SEARCH', newVal)
        this.$store.commit('home/staffMyApproval/RESET_CURRENT_PAGE')
      }
    },
    app_type_id: {
      get() {
        return this.$store.state.home.staffMyApproval.app_type_id
      },
      set(val) {
        this.$store.commit('home/staffMyApproval/SET_APP_TYPE_ID', val)
      }
    },
    approve_status: {
      get() {
        return this.$store.state.home.staffMyApproval.approve_status
      },
      set(val) {
        this.$store.commit('home/staffMyApproval/SET_APPROVE_STATUS', val)
      }
    },
    columns() {
      return [
        { name: this.$t('homePage.requestDate') },
        { name: this.$t('homePage.requester') },
        { name: this.$t('homePage.className') },
        { name: this.$t('homePage.subjectName') },
        { name: this.$t('homePage.status'), style: 'text-align: center' },
        { name: this.$t('homePage.comments') },
        { name: this.$t('actions'), style: 'text-align: center; width: 1px' }
      ]
    }
  },
  methods: {
    fetchResource() {
      this.$store
        .dispatch('home/staffMyApproval/fetchResource')
        .then(() => {
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch('home/staffMyApproval/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },
    showReasonForm(app_status_id, data) {
      this.$modal.show(
        ReasonComponent,
        {
          app_status_id: app_status_id,
          data: data
        },
        {
          height: 'auto',
          width: '300px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    },
    onView(record) {
      if (record.app_type_id == 3) {
        this.view_homework = true
        this.homework = record
      }
      if (record.app_type_id == 1 && record.requester_type == 'Father') {
        this.view_father = true
        this.father = record
      }
      if (record.app_type_id == 1 && record.requester_type == 'Mother') {
        this.view_mother = true
        this.mother = record
      }
      if (record.app_type_id == 2) {
        this.view_student = true
        this.student = record
      }
    },
    closeHomeworkModel() {
      this.view_homework = false
      this.homework = []
    },
    closeFatherModel() {
      this.view_father = false
      this.father = []
    },
    closeMotherModel() {
      this.view_homework = false
      this.mother = []
    },
    closeStudentModel() {
      this.view_homework = false
      this.student = []
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    app_type_id: debounce(function(app_type_id) {
      this.fetchData({ app_type_id })
    }, 500),
    approve_status: debounce(function(approve_status) {
      this.fetchData({ approve_status })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('home/staffMyApproval/RESET_STATE')
    this.$store.commit('home/staffMyApproval/SET_APPROVE_STATUS', '')
    this.$store.commit('home/staffMyApproval/SET_APP_TYPE_ID', 3)
    next()
  }
}
</script>
